import React from "react";
import IntegrationDataMapping from "../shared/IntegrationDataMapping";
import { getScopeOptions } from "./AccelaScopeOptions";

interface Props {
  teamId: number;
  selectedConfigId: number;
}

const SCOPE_OPTIONS = getScopeOptions();

export default function AccelaDataMapping(props: Props) {
  return (
    <IntegrationDataMapping
      selectedConfigId={props.selectedConfigId}
      teamId={props.teamId}
      description="Configure which Accela fields appear in the agent CRM sidebar and as workflow variables."
      fieldKey="accelaField"
      fieldLabel="Accela Field"
      apiPrefix="Accela/Integrations"
      getFieldsPath="GetAccelaFields"
      scopeOptions={SCOPE_OPTIONS}
    />
  );
}
